<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <form
          @submit.prevent="submit"
          novalidate
          class="login100-form validate-form"
        >
          <span class="login100-form-title p-b-43">
            Login
          </span>

          <div class="wrap-input100 validate-input">
            <input class="input100" v-model="username" type="text" />
            <span class="focus-input100"></span>
            <span class="label-input100">ชื่อผู้ใช้</span>
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              v-model="password"
              type="password"
              name="pass"
            />
            <span class="focus-input100"></span>
            <span class="label-input100">รหัสผ่าน</span>
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" type="submit">
              Login
            </button>
          </div>
        </form>

        <div class="login100-more image"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    submit() {
      if (this.username == '') {
        this.$swal.fire({
          icon: 'warning',
          title: 'Login',
          text: 'ยังไม่ได้ใส่ชื่อผู้ใช้',
        })
        return
      }

      if (this.password == '') {
        this.$swal.fire({
          icon: 'warning',
          title: 'Login',
          text: 'ยังไม่ได้ใส่รหัสผ่าน',
        })

        return
      }

      var params = new URLSearchParams()
      params.append('username', this.username)
      params.append('password', this.password)
      this.$http({
        method: 'post',
        url: 'api/customer/customerlogin',
        params: params,
      })
        .then((response) => {
          if (response.status == '200') {
          //  location.reload()
            window.localStorage.setItem('token', response.data.token)
            window.localStorage.setItem('customerid', response.data.customerId)
            this.$cookies.set("refreshToken",response.data.refreshToken,"4h");
           // alert(this.$cookies.get("refreshToken")) 
           // window.localStorage.setItem("refreshToken",response.data.refreshToken)
            window.localStorage.setItem('authenticated', true)
            let date = new Date()
            window.localStorage.setItem('date', date)
            // alert(date)
            //  alert (window.localStorage.getItem('date'));
            this.$router.push('/dashboard')
          //  location.reload()
          } else if (response.status == '204') {
            this.$swal.fire({
              icon: 'info',
              title: 'Authorize',
              text: 'ไม่พบชื่อผู้ใช้',
            })
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            if (error.response.status == '401') {
              this.$swal.fire({
                icon: 'error',
                title: 'Authorize',
                text: 'ไม่พบสิทธิ์การใช้งาน',
              })
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              text: error,
            })
          }
        })
    },

    logout() {
      window.localStorage.clear()
    },
  },

  computed: {
    usernameError() {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.required && errors.push('กรุณาใส่ชื่อผู้ใช้')
      return errors
    },

    passwordError() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('กรุณาใส่รหัสผ่าน')
      return errors
    },
  },

  beforeCreate() {
   // window.localStorage.clear()

    /*
if (window.localStorage.getItem('token') != undefined) {
      // this.$router.push("/dashboard");
      window.location.href = '/dashboard'
    }
    */
  },

  validations: {
    username: { required },
    password: { required },
  },
}
</script>

<
<style scoped lang="css">
@import '/images/icons/favicon.ico';
@import 'vendor/bootstrap/css/bootstrap.min.css';
@import 'fonts/font-awesome-4.7.0/css/font-awesome.min.css';
@import 'fonts/Linearicons-Free-v1.0.0/icon-font.min.css';
@import 'vendor/animate/animate.css';
@import 'vendor/css-hamburgers/hamburgers.min.css';
@import 'vendor/animsition/css/animsition.min.css';
@import 'vendor/select2/select2.min.css';
@import 'vendor/daterangepicker/daterangepicker.css';
@import 'css/util.css';
@import 'css/main.css';

.image {
  background-image: url('images/PW.jpg');
  background-repeat: no-repeat;
}
</style>
